import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '../services/account.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AccountService);
  const router = inject(Router);

  if (authService.isLoggedIn) {
    return true;
  }
  const url = state.url.replace(/^\/+/, ''); // Remove leading "/"
  router.navigate(['/'], { queryParams: { returnUrl: url } });
  return false;
};
